import React from "react";
import PropTypes from "prop-types";
// Limitless imports
import RewardDetails from "./rewards-detailed-content/RewardDetails";
import Grid from "@limitless/modern/layout/Grid";
import Typography from "@limitless/modern/data-display/typography/Typography";
import ArrowDown from "@limitless/icons/ArrowDown";
import IconButton from "@limitless/modern/inputs/icon-button/IconButton";
import ArrowUp from "@limitless/icons/ArrowUp";

const PaymentTabContent = ({ rewardQuestion, isPendingReward, theme, handleToggle, header, tab }) => {
    const [expandedAllItem, setExpandedAllItem] = React.useState(false);
    const [expandedItem, setExpandedItem] = React.useState([]);

    React.useEffect(() => {
        setExpandedAllItem(false);
        setExpandedItem([]);
    }, [tab]);

    const handleAccordionChange = index => {
        const item = rewardQuestion.filtered[index];
        if (item.type !== "Incentive") {
            const isExpanded = expandedItem.includes(index);
            let updatedExpandedItem = [];

            if (isExpanded) {
                updatedExpandedItem = expandedItem.filter(expandedIndex => expandedIndex !== index);
            } else {
                updatedExpandedItem = [index];
            }

            setExpandedItem(updatedExpandedItem);
        }
    };

    const handleExpandAll = () => {
        const expandedItems = expandedAllItem
            ? []
            : rewardQuestion.filtered.flatMap((item, index) => (item.type !== "Incentive" ? index : []));
        setExpandedItem(expandedItems);
        setExpandedAllItem(!expandedAllItem);
    };

    return (
        <>
            <Grid container>
                <Grid item xs={8}>
                    <Typography variant="caption" color="text.secondary">
                        {header}
                    </Typography>
                    {isPendingReward && (
                        <Typography
                            style={{
                                color: theme.palette.primary.main,
                                display: "inline",
                                cursor: "pointer"
                            }}
                            color="primary.main"
                            variant="caption"
                            id="contactUs"
                            onClick={() => handleToggle(true)}
                        >
                            Learn more
                        </Typography>
                    )}
                </Grid>
                <Grid item xs={4} display="flex" justifyContent="flex-end" container>
                    <Typography variant="textButton" color="text.primary" style={{ marginRight: "6px" }}>
                        {expandedAllItem ? "Collapse All" : "Expand All"}
                    </Typography>
                    <IconButton
                        label=""
                        style={{marginTop:"5px"}}
                        icon={expandedAllItem ? <ArrowUp /> : <ArrowDown />}
                        id="expandAllIcon"
                        onClick={handleExpandAll}
                    />
                </Grid>
            </Grid>
            <RewardDetails
                theme={theme}
                expandedItem={expandedItem}
                handleAccordionChange={handleAccordionChange}
                rewardQuestion={rewardQuestion}
                expandedAllItem={expandedAllItem}
                isPendingReward={isPendingReward}
            />
        </>
    );
};

PaymentTabContent.propTypes = {
    rewardQuestion: PropTypes.object.isRequired,
    isPendingReward: PropTypes.bool,
    theme: PropTypes.object,
    handleToggle: PropTypes.func,
    header: PropTypes.string,
    tab: PropTypes.number
};

export default PaymentTabContent;
